import { createSwiper } from '@nulo/swiper';
import { whenNearViewport } from '@nulo/a11y';

/**
 * @extends {HTMLElement}
 */
class ReviewSlider extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;

  connectedCallback() {
    this.#scheduleSwiper();
  }

  disconnectedCallback() {
    this.#swiper?.destroy?.(true, true);
    this.#swiper = null;
  }

  async #scheduleSwiper() {
    if (this.#swiper) return;

    await whenNearViewport(this);
    if (!this.isConnected || this.#swiper) return;

    const swiperEl = this.querySelector('[data-swiper]');
    if (!(swiperEl instanceof HTMLElement)) return;

    this.#swiper = createSwiper({
      region: this,
      el: swiperEl,
      activeSlideClass: 'swiper-slide-fully-visible',
      config: {
        slidesPerView: 1.3,
        spaceBetween: 0,
        navigation: {
          nextEl: this.querySelector('.review-slider__nav--next'),
          prevEl: this.querySelector('.review-slider__nav--prev'),
        },
        breakpoints: {
          767: { slidesPerView: 1.29 },
          991: { slidesPerView: 1.2 },
          1199: { slidesPerView: 1.4 },
          1500: { slidesPerView: 1.4 },
          1700: { slidesPerView: 1.5 },
        },
      },
    });
  }
}

if (!customElements.get('review-slider')) {
  customElements.define('review-slider', ReviewSlider);
}
